import { Pill, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { Button } from "../../../components/Button";
import { ShiftCardWrapper } from "../../../Shift/Card/Wrapper";

interface RestrictedBannerProps {
  liftTime?: string;
  onCtaClick: () => void;
}

export function RestrictedBanner({ liftTime, onCtaClick }: RestrictedBannerProps) {
  return (
    <ShiftCardWrapper
      sx={(theme) => ({
        padding: theme.spacing(5),
        background: theme.palette.onboarding?.error?.gradient,
      })}
    >
      <Stack spacing={5} alignItems="center" textAlign="center">
        {liftTime && (
          <Pill
            iconType="clock-filled"
            label={`Lifts on ${liftTime}`}
            size="small"
            sx={{ display: "inline-flex", backgroundColor: `rgba(255, 255, 255, 0.4)` }}
          />
        )}

        <Text
          semibold
          variant="h5"
          sx={(theme) => ({
            color: theme.palette.error.main,
          })}
        >
          Your account is Restricted
        </Text>

        <Text variant="body2">
          Your account has been temporarily restricted from booking shifts due to recent
          cancellations or tardiness.
        </Text>

        <Button variant="outlined" size="small" onClick={onCtaClick}>
          Learn more
        </Button>
      </Stack>
    </ShiftCardWrapper>
  );
}
